var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7731 4.46971C10.6324 4.32911 10.4417 4.25012 10.2428 4.25012C10.044 4.25012 9.85323 4.32911 9.71259 4.46971L6.00009 8.18221L2.28759 4.46971C2.14613 4.3331 1.95668 4.2575 1.76004 4.25921C1.56339 4.26092 1.37528 4.33979 1.23622 4.47885C1.09717 4.61791 1.01829 4.80602 1.01658 5.00266C1.01487 5.19931 1.09047 5.38876 1.22709 5.53021L5.46984 9.77296C5.61048 9.91357 5.80121 9.99255 6.00009 9.99255C6.19896 9.99255 6.38969 9.91357 6.53034 9.77296L10.7731 5.53021C10.9137 5.38957 10.9927 5.19884 10.9927 4.99996C10.9927 4.80109 10.9137 4.61036 10.7731 4.46971Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1ea596d4423bad65a56488f3ca0045a0.svg";
export { ForwardRef as ReactComponent };